// Copyright (c) 2016 Deere & Company

export default [
    ['account', 'account'],
    ['account', 'name'],
    ['account', 'location', 'city'],
    ['claimNumber'],
    ['dtac'],
    ['firstShipToLocation', 'name'],
    ['partDescription'],
    ['partNumber'],
    ['pin'],
    ['reference1'],
    ['requestType', 'value'],
    ['rgaNumber'],
    ['returnStatus', 'description']
];



// WEBPACK FOOTER //
// ./src/part-requests/shared/state/part-return-filter-options.js